import { createIterable, log } from '@deck.gl/core';
import { nest } from 'd3';
import { cellToBoundary, cellToLatLng } from 'h3-js';

/**
 * Use h3 hexagons to aggregate points.
 * Based off of the hexbin aggregator from deckgl:
 * https://github.com/uber/deck.gl/blob/7.1-release/modules/aggregation-layers/src/hexagon-layer/hexagon-aggregator.js
 */
export const pointToHex =
  (resolution = 7) =>
  (
    { data, getPosition }: any,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    viewport: any
  ) => {
    // get deck iterator over the points
    const { iterable, objectInfo } = createIterable(data);

    // for each point, compute the h3 hex ID
    const hexPoints = [];
    for (const point of iterable) {
      // get the position and ensure it is valid
      objectInfo.index++;
      const position = getPosition(point, objectInfo);
      const arrayIsFinite =
        Number.isFinite(position[0]) && Number.isFinite(position[1]);

      if (arrayIsFinite) {
        hexPoints.push({
          h3HexId: cellToBoundary(position[1], position[0], resolution),
          ...point,
        });
      } else {
        log.warn('H3HexagonAggregator: invalid position')();
      }
    }

    // group by hex ID
    const groupedHexPoints = nest()
      .key((d: any) => d.h3HexId)
      .entries(hexPoints);

    // use the center of each h3 hexagon as the position
    const hexagons = groupedHexPoints.map((group, index) => {
      const [centerLat, centerLng] = cellToLatLng(group.key);
      return {
        position: [centerLng, centerLat],
        points: group.values,
        index,
      };
    });

    return { hexagons };
  };
